import { useMemo, useState, type PropsWithChildren } from 'react'

import { EventsContext, type EventsContextValue, type EventTypeFilter } from './EventsContext'
import type { EventsPeriod } from './eventsPeriod'

/**
 * Фильтры и выбранное событие живут на уровне приложения, а не страницы:
 * при переходе на другую вкладку и обратно журнал открывается в том же состоянии.
 */
export function EventsProvider({ children }: PropsWithChildren) {
  const [type, setType] = useState<EventTypeFilter>('all')
  const [period, setPeriod] = useState<EventsPeriod>('all')
  const [selectedId, select] = useState<string | null>(null)

  const value = useMemo<EventsContextValue>(
    () => ({ type, setType, period, setPeriod, selectedId, select }),
    [type, period, selectedId],
  )

  return <EventsContext.Provider value={value}>{children}</EventsContext.Provider>
}
